import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { ListadaAgrupada, ConfigService } from '../../../infrastructure/services/config.service';
import { Subscription } from 'rxjs';
import { Observable } from 'rxjs/Observable';

@Component({
    templateUrl: './configurar.paymentGateway.component.html',
})
export class ConfigurarPaymentComponent implements OnInit, OnDestroy {
    readonly level = 'Payment';

    systemCode: string;
    organizationCode: string;
    pgCode: string;

    grupos: Observable<ListadaAgrupada[]>;
    cargando: Boolean = true;
    subsGetConfiguracion: Subscription;

    constructor(private aRoute: ActivatedRoute, private configService: ConfigService) { }

    ngOnInit() {
        // URL parameters
        this.systemCode = this.aRoute.snapshot.params.codsistema;
        this.organizationCode = this.aRoute.snapshot.params.codorganizacion;
        this.pgCode = this.aRoute.snapshot.params.pgcode;

        this.grupos = this.configService.getConfiguracion(
            this.organizationCode,
            this.systemCode, 
            null, 
            null, 
            this.level, 
            this.pgCode);
    }

    ngOnDestroy() {
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/configuracion/paymentGateway/configurar.paymentGateway.component.ts